var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        visible: _vm.visible,
        title: _vm.$t("auto.editText"),
        closable: false,
        maskClosable: false,
      },
      on: { ok: _vm.save, cancel: _vm.cancel },
    },
    [
      _c("div", [
        _c(
          "div",
          { staticStyle: { "margin-bottom": "8px" } },
          [
            _c("p", { staticStyle: { "margin-bottom": "4px" } }, [
              _vm._v(_vm._s(_vm.$t("auto.textContent"))),
            ]),
            _vm._v(" "),
            _c("a-input", {
              staticStyle: { width: "100%" },
              on: { input: _vm.onTextInput },
              model: {
                value: _vm.tempEditText,
                callback: function ($$v) {
                  _vm.tempEditText = $$v
                },
                expression: "tempEditText",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticStyle: { "margin-bottom": "8px" } }, [
          _c("p", { staticStyle: { "margin-bottom": "4px" } }, [
            _vm._v(_vm._s(_vm.$t("auto.color"))),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: {
                display: "flex",
                "flex-wrap": "wrap",
                gap: "4px",
                "align-items": "center",
              },
            },
            _vm._l(_vm.colors, function (color) {
              return _c("div", {
                key: color,
                style: {
                  backgroundColor: color,
                  width: "24px",
                  height: "24px",
                  borderRadius: "50%",
                  marginRight: "4px",
                  cursor: "pointer",
                  border:
                    _vm.tempEditColor === color
                      ? "2px solid #1890ff"
                      : "1px solid #e8e8e8",
                },
                on: {
                  click: function ($event) {
                    return _vm.selectColor(color)
                  },
                },
              })
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          [
            _c("p", { staticStyle: { "margin-bottom": "4px" } }, [
              _vm._v(_vm._s(_vm.$t("auto.sizePx"))),
            ]),
            _vm._v(" "),
            _c("a-slider", {
              attrs: { min: 10, max: 60, step: 1 },
              on: { change: _vm.onSizeChange },
              model: {
                value: _vm.tempEditSize,
                callback: function ($$v) {
                  _vm.tempEditSize = $$v
                },
                expression: "tempEditSize",
              },
            }),
            _vm._v(" "),
            _c(
              "p",
              { staticStyle: { "margin-left": "4px", "margin-top": "6px" } },
              [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("auto.selectedSize")) +
                    ": " +
                    _vm._s(_vm.tempEditSize) +
                    _vm._s(_vm.$t("message.pixelUnit")) +
                    "\n      "
                ),
              ]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }